<template>
    <base-modal hideClose :title="$t('filtersTitle')" v-model="localValue">
      <b-row>
        <b-col cols="12" class="mb-3"><base-select clearable :options="activitySource" valueProp="id" :label="normalizeForumProp('name')" v-model="filters.activity" :placeholder="$t(`activity`)" :loading="false"></base-select></b-col>
        <b-col cols="12" class="mb-3"><base-select clearable :options="activityLevelSource" valueProp="id" :label="normalizeForumProp('name')" v-model="filters.activityLevel" :placeholder="$t(`level`)"></base-select></b-col>
        <b-col cols="12" class="mb-3"><base-select clearable :options="countrySource" valueProp="idCountry" :label="$i18nHelpers.normalizeProp('name')" @option:selected="countryChange" v-model="filters.country" :placeholder="$t(`country`)"></base-select></b-col>
        <b-col cols="12" class="mb-3"><base-select clearable :options="stateSource" valueProp="id" :label="$i18nHelpers.normalizeProp('name')" @option:selected="stateChange" v-model="filters.state" :placeholder="$t(`state`)"></base-select></b-col>
        <b-col cols="12" class="mb-3"><base-select clearable :options="citySource" valueProp="idCity" :label="$i18nHelpers.normalizeProp('name')" v-model="filters.city" :placeholder="$t(`city`)" :loading="false" :noOptionsTitle="$t('selectState')"></base-select></b-col>
        <b-col cols="12" class="mb-3"><base-datepicker :class="!showingCalendar ? 'dateActivitySearch' : null" @shown="showingCalendar = true" @hidden="showingCalendar = false" noMarginBottom dateAfterNow resetButtton v-model="filters.date" :placeholder="$t('date').toUpperCase()"></base-datepicker></b-col>
        <b-col cols="12" class="mb-3"><base-select clearable :options="timeOfDaySource" valueProp="id" label="name" v-model="filters.timeOfDay" :placeholder="$t(`hour`)"></base-select></b-col>
      </b-row>
      <div class="search-btn mt-4">
          <base-button @click="filter">{{$t('search')}}</base-button>
          <base-button gray @click="resetFilters">{{$t('cancel')}}</base-button>
      </div>
    </base-modal>
  </template>
  
<script>
import BaseModal from '@/components/base/BaseModal'
import BaseDatepicker from '@/components/base/forms/BaseDatepicker'
import forumMixin from '@/mixins/forum.mixin'
import forumRepository from '@/repositories/ForumRepository'
import geographyRepository from '@/repositories/GeographyRepository'
import { MX_COUNTRY_ID, SPAIN_COUNTRY_ID } from '@/constants/db/countries'
import { inMx } from '@/helpers/global.helpers'
import wrapperMixin from '@/mixins/wrapper.mixin'

const OTHER_ACTIVITIES_ID = '000000000000000000000000'

export default {
    components: {
        BaseModal,
        BaseDatepicker
    },
    mixins: [wrapperMixin(Boolean), forumMixin],
    created () {
        this.getActivities()
        this.getActivitiesLevel()
        this.getCountries()
        this.getStates()
        if (Object.keys(this.$store.state.forum.activityFilters).length) {
            this.filters = this.$store.state.forum.activityFilters
        }
    },
    data () {
        return {
            showingCalendar: false,
            activitySource: [],
            activityLevelSource: [],
            countrySource: [],
            stateSource: [],
            citySource: [],
            timeOfDaySource: [{id: 1, name: this.$t('timeOfDay.morning')}, {id: 2, name: this.$t('timeOfDay.afternoon')}, {id: 3, name: this.$t('timeOfDay.night')}],
            filters: {
                activity: null,
                activityLevel: null,
                country: inMx ? MX_COUNTRY_ID : SPAIN_COUNTRY_ID,
                state: null,
                city: null,
                date: null,
                timeOfDay: null,
                sortId: null
            }
        }
    },
    methods: {
        getActivities () {
            forumRepository.getActivities(true).then(response => {
                this.activitySource = response.data
            })
        },
        getActivitiesLevel () {
            forumRepository.getActivitiesLevel().then(response => {
                this.activityLevelSource = response.data
            })
        },
        getCountries () {
            geographyRepository.getCountries().then(response => {
                this.countrySource = response.data
            })
        },
        getStates () {
            geographyRepository.getStatesByCountry(this.filters.country).then(response => {
                this.stateSource = response.data
            })
        },
        getCities () {
            geographyRepository.getStateCities(this.filters.state).then(response => {
                this.citySource = response.data
            })
        },
        countryChange () {
            this.getStates()
            this.citySource = []
            this.filters.state = null
            this.filters.city = null
        },
        stateChange () {
            this.filters.city = null
            this.getCities()
        },
        filter () {
            this.filters.sortId = this.$store.state.forum.searchSort
            this.$store.commit('forum/setActivityFilters', this.filters)
            forumRepository.searchActivity(this.filters).then(response => {
                if (response.data && response.data.entryData.length > 0) {
                    this.processForumEntry(response.data)
                    this.$store.commit('forum/setActivityFilterSelected', this.filters.activity && this.activitySource.some(item => item.id === this.filters.activity && item.createdByUser) ? OTHER_ACTIVITIES_ID : this.filters.activity)
                    this.$router.push(this.getPathUrl()).catch(() => {})
                } else {
                    this.$store.dispatch('showInfoAlert', this.$t('emptyActivitiesSearch'))
                    this.resetActivityFiltersStore()
                }
            })
            this.localValue = false
        },
        resetFilters () {
            Object.keys(this.filters).forEach(key => { this.filters[key] = null })
            this.resetActivityFiltersStore()
            this.localValue = false
        },
        resetActivityFiltersStore () {
            this.$store.commit('forum/setActivityFilters', {})
            this.$store.commit('forum/setActivityFilterSelected', null)
        }
    }
}
</script>

<style lang="scss" scoped>
.search-btn{
    text-align: center;
}
/deep/ .dateActivitySearch .btn{
    position: absolute !important;
    top: 50%;
    transform: translateY(-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/views/healthy-community/forum/ForumActivitySearch.vue